import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import css from './index.css';
import AddressInformation from '../addressInformation';
import {setCalculate} from '~/modules/rate/actions';
import mapDispatch from '~/misc/mapDispatch';

class FuelCalculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fuelPrice: '',
      basePrice: '',
      milesPrice: '',
      fuelCost: 0,
      fuelCostMile: 0,
      fuelSurcharge: 0,
      fuelSurchargeMile: 0,
      fuelError: '',
      baseError: '',
      milesError: '',
    };
    this.fuelChange = this.fuelChange.bind(this);
    this.baseChange = this.baseChange.bind(this);
    this.milesChange = this.milesChange.bind(this);
    this.submit = this.submit.bind(this);
    this.init = this.init.bind(this);
  }
  componentWillMount() {
    this.setState({
      fuelPrice: this.props.fuelPrice ? this.props.fuelPrice : 3,
      basePrice: this.props.basePrice ? this.props.basePrice : 2.8,
      milesPrice: this.props.milesPrice ? this.props.milesPrice : 5.5,
    });
  }
  componentDidMount() {
    if (this.state.fuelPrice && this.state.basePrice && this.state.milesPrice) {
      this.init();
    }
  }
  fuelChange(event) {
    const basePrice = this.state.basePrice;
    let value = event.target.value;
    this.setState({fuelPrice: value, fuelError: ''});
    if (!value) {
      this.setState({fuelError: 'You can\'t leave this empty.'});
      return null;
    } else if (value.replace(/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]+$)/, '')) {
      this.setState({fuelError: 'Please enter a correct number.'});
      return null;
    } else if (value && basePrice && Number(basePrice) > Number(value)) {
      this.setState({baseError: 'It should be smaller than Fuel Cost Per Gallon.'});
      return null;
    } else if (value && basePrice && Number(basePrice) < Number(value)) {
      this.setState({baseError: ''});
      return null;
    }
  }
  baseChange(event) {
    const fuelPrice = this.state.fuelPrice;
    let value = event.target.value;
    this.setState({basePrice: value, baseError: ''});
    if (!value) {
      this.setState({baseError: 'You can\'t leave this empty.'});
      return null;
    } else if (value.replace(/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]+$)/, '')) {
      this.setState({baseError: 'Please enter a correct number.'});
      return null;
    } else if (value && fuelPrice && Number(value) > Number(fuelPrice)) {
      this.setState({baseError: 'It should be smaller than Fuel Cost Per Gallon.'});
      return null;
    }
  }
  milesChange(event) {
    let value = event.target.value;
    this.setState({milesPrice: value, milesError: ''});
    if (!value) {
      this.setState({milesError: 'You can\'t leave this empty.'});
      return null;
    } else if (value.replace(/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]+$)/, '')) {
      this.setState({milesError: 'Please enter a correct number.'});
      return null;
    }
  }
  submit(event) {
    event.preventDefault();
    this.init();
  }
  init() {
    const distance = this.props.distance;
    const fuelPrice = this.state.fuelPrice;
    const basePrice = this.state.basePrice;
    const milesPrice = this.state.milesPrice;
    if (!this.state.fuelError && !this.state.baseError && !this.state.milesError) {
      this.props.setCalculate({fuelPrice, basePrice, milesPrice});
      this.setState({
        fuelCost: (fuelPrice / milesPrice * distance).toFixed(2),
        fuelCostMile: (fuelPrice / milesPrice).toFixed(2),
        fuelSurcharge: ((fuelPrice - basePrice) / milesPrice * distance).toFixed(2),
        fuelSurchargeMile: ((fuelPrice - basePrice) / milesPrice).toFixed(2),
      });
    }
  }
  render() {
    const distance = this.props.distance;
    return (
      <div className={cs(css.fuelCalculator)}>
        <div className={cs(css.calculator)}>
          <form>
            <div className={cs(css.item)}>
              <label>fuel cost per gallon</label>
              <input
                className={cs(css.input, css.hasIcon)}
                name='fuelPrice'
                value={this.state.fuelPrice}
                onChange={this.fuelChange}
              />
              <span className={cs(css.dollar)}>$</span>
              <div className={cs(css.error)}>{this.state.fuelError}</div>
            </div>
            <div className={cs(css.item)}>
              <label>baseline fuel price</label>
              <input
                className={cs(css.input, css.hasIcon)}
                name='basePrice'
                value={this.state.basePrice}
                onChange={this.baseChange}
              />
              <span className={cs(css.dollar)}>$</span>
              <div className={cs(css.error)}>{this.state.baseError}</div>
            </div>
            <div className={cs(css.item)}>
              <label>Miles per gallon</label>
              <input
                className={cs(css.input)}
                name='milesPrice'
                value={this.state.milesPrice}
                onChange={this.milesChange}
              />
              <div className={cs(css.error)}>{this.state.milesError}</div>
            </div>
            <button className={cs(css.formSubmit)} onClick={this.submit}>Recalculate</button>
          </form>
        </div>
        <div className={cs(css.results)}>
          <div className={cs(css.estimated)}>
            <div className={cs(css.resultsHeader)}>Estimated Fuel Cost at {this.state.milesPrice} MPG</div>
            <div className={cs(css.resultsContent)}>
              <div className={cs(css.specificInformation)}>
                <div className={cs(css.informationLabel)}>Est.Fuel Cost / Mile</div>
                <div className={cs(css.informationNumber)}><span>$ </span>{this.state.fuelCostMile}</div>
              </div>
              <div className={cs(css.border)} />
              <div className={cs(css.specificInformation)}>
                <div className={cs(css.informationLabel)}>Distance</div>
                <div className={cs(css.informationNumber)}>{distance}mi</div>
              </div>
              <div className={cs(css.border)} />
              <div className={cs(css.specificInformation)}>
                <div className={cs(css.informationLabel)}>Est. Fuel Cost</div>
                <div className={cs(css.informationNumber)}><span>$ </span>{this.state.fuelCost}</div>
              </div>
            </div>
          </div>
          <div className={cs(css.surcharge, css.estimated)}>
            <div className={cs(css.resultsHeader)}>Fuel Surcharge Calculate</div>
            <div className={cs(css.resultsContent)}>
              <div className={cs(css.specificInformation)}>
                <div className={cs(css.informationLabel)}>Fuel Surcharge Rate / Mile</div>
                <div className={cs(css.informationNumber)}><span>$ </span>{this.state.fuelSurchargeMile}</div>
              </div>
              <div className={cs(css.border)} />
              <div className={cs(css.specificInformation)}>
                <div className={cs(css.informationLabel)}>Total Fuel Surcharge</div>
                <div className={cs(css.informationNumber)}><span>$ </span>{this.state.fuelSurcharge}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(({rate}, props) => ({
  fuelPrice: props.fuelPrice ? props.fuelPrice : rate.fuelPrice,
  basePrice: props.basePrice ? props.basePrice : rate.basePrice,
  milesPrice: props.milesPrice ? props.milesPrice : rate.milesPrice,
}), mapDispatch({
  setCalculate: (props, data) => setCalculate(data),
}))(FuelCalculator);



// WEBPACK FOOTER //
// ./src/components/rate/common/fuelCalculator/index.js